
<div class="card-view">
  <card-profile
    :id="$route.params.id"
    :profile-type="$route.query.profile"
    page
  />
</div>
